<div class="header">
  <div class="title">Preview</div>
  <div class="spacer"></div>
  @if (!!noPreviewMessage) {
    <div class="send-test-message">
      {{ noPreviewMessage }}
    </div>
  }
  @if (!noPreviewMessage) {
    <div class="send-test">
      @if (!sendingTest) {
        <div
          [matTooltipDisabled]="canSendPreview"
          matTooltip="Please save your changes before sending a test."
          >
          <button mat-stroked-button color="primary" (click)="sendTest.emit()" [disabled]="!canSendPreview">
            Send Test
          </button>
        </div>
      }
      @if (sendingTest) {
        <mat-spinner [diameter]="24"></mat-spinner>
      }
    </div>
  }
</div>
<mat-divider></mat-divider>
@if (!inApp) {
  <div class="devices">
    <button mat-button (click)="setFrameWidth('100%')">
      <mat-icon>laptop</mat-icon>
      Desktop
    </button>
    <button mat-button (click)="setFrameWidth('600px')">
      <mat-icon>tablet_mac</mat-icon>
      Tablet
    </button>
    <button mat-button (click)="setFrameWidth('320px')">
      <mat-icon>phone_iphone</mat-icon>
      Mobile
    </button>
  </div>
}
@if (!inApp) {
  <mat-divider></mat-divider>
}
<div class="container">
  <div class="error">
    @if (error) {
      <mat-card appearance="outlined">
        <mat-icon>error_outline</mat-icon>
        {{ error }}
      </mat-card>
    }
  </div>
  @if (inApp) {
    <div class="preview">
      <div class="sample-container">
        <div class="sample mat-elevation-z1">
          <div [innerHTML]="_html"></div>
          <div class="time">an hour ago</div>
        </div>
      </div>
    </div>
  }
  @if (!inApp) {
    <div class="frame-preview preview">
      <iframe #frame class="frame" sandbox="allow-same-origin allow-popups" [style.width]="width"></iframe>
    </div>
  }
</div>
